import { useTranslation } from "react-i18next";

import { Button } from "@/modules/theme/components/Button/Button";
import { DialogButtonsWrapper } from "@/modules/theme/components/Dialog/components/DialogButtonsWrapper";
import { Dialog } from "@/modules/theme/components/Dialog/Dialog";

import { useSignOutMutation } from "./hooks/useSignOutMutation";

const translationNamespace = "pages/MoreMenuPage";

export function SignOutDialog({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  const { t } = useTranslation(translationNamespace);
  const signOutMutation = useSignOutMutation();

  return (
    <Dialog
      isOpen={isOpen || signOutMutation.status === "loading"}
      onClose={onClose}
      description={t("Are you sure you want to sign out?")}
    >
      <DialogButtonsWrapper>
        <Button onClick={onClose} variant="secondary">
          {t("Cancel")}
        </Button>
        <Button
          isLoading={signOutMutation.status === "loading"}
          isDisabled={signOutMutation.status === "loading"}
          onClick={() => {
            onClose();
            signOutMutation.mutate(undefined);
          }}
        >
          {t("Sign out")}
        </Button>
      </DialogButtonsWrapper>
    </Dialog>
  );
}
